"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableConfig = exports.createTableCellNode = exports.createTableRepeatingRowNode = exports.createTableRowNode = void 0;
var react_1 = __importDefault(require("react"));
var GetCommonConfigByType_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetCommonConfigByType");
var MakeConfig_1 = require("../Utils/MakeConfig");
var slate_1 = require("slate");
var lodash_1 = require("lodash");
var TableWidget_1 = __importDefault(require("Project/QwilrEditor/Widgets/TableWidget/TableWidget"));
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var Deserialise_1 = require("Project/QwilrEditor/Tokenization/Deserialise");
var Paragraph_1 = require("./Paragraph");
var Utils_1 = require("Project/QwilrEditor/Utils");
var slate_react_1 = require("slate-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var TelemetryParameterValue_1 = require("@CommonFrontend/Telemetry/TelemetryParameterValue");
var Serialise_1 = require("Project/QwilrEditor/Tokenization/Serialise");
var TokenizationErrorRecorder_1 = require("Project/QwilrEditor/Tokenization/TokenizationErrorRecorder");
var createTableNode = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.rows, rows = _c === void 0 ? 2 : _c, _d = _b.columns, columns = _d === void 0 ? 2 : _d;
    return ({
        type: "table",
        isVoid: false,
        data: {
            rows: rows,
            columns: columns,
            columnBorders: (0, lodash_1.range)(0, columns + 1).map(function (borderIndex) { return (100 / columns) * borderIndex; }),
        },
        children: (0, lodash_1.range)(0, rows).map(function () { return (0, exports.createTableRowNode)({ columns: columns }); }),
    });
};
var createTableRowNode = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.columns, columns = _c === void 0 ? 0 : _c;
    return ({
        type: "tableRow",
        isVoid: false,
        children: (0, lodash_1.range)(0, columns).map(function () { return (0, exports.createTableCellNode)(); }),
    });
};
exports.createTableRowNode = createTableRowNode;
var createTableRepeatingRowNode = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.columns, columns = _c === void 0 ? 0 : _c, repeatingToken = _b.repeatingToken;
    return ({
        type: "tableRepeatingRow",
        isVoid: false,
        data: {
            repeatingToken: repeatingToken,
        },
        children: (0, lodash_1.range)(0, columns).map(function () { return (0, exports.createTableCellNode)(); }),
    });
};
exports.createTableRepeatingRowNode = createTableRepeatingRowNode;
var createTableCellNode = function () { return ({
    type: "tableCell",
    isVoid: false,
    children: [(0, Paragraph_1.createParagraphNode)()],
}); };
exports.createTableCellNode = createTableCellNode;
exports.tableConfig = (0, MakeConfig_1.makeConfig)(__assign(__assign({}, (0, GetCommonConfigByType_1.getCommonConfigByType)("table")), { node: {}, nodeType: "layoutElement", editorRender: function (props) { return react_1.default.createElement(TableWidget_1.default, __assign({}, props)); }, firstLastConfiguration: { isValidFirstChild: false }, width: "full-width", deserialise: function (token, content, commentTracker) {
        var tableNode = {
            type: "table",
            isVoid: false,
            data: {
                rows: token.cells.length,
                columns: token.cells[0].length,
                columnBorders: token.columnBorders,
            },
            children: [],
        };
        var currRowNum = 0;
        var _loop_1 = function (i) {
            var e_1, _a;
            var row = token.cells[i];
            var repeatingRow = token.repeatingRows && token.repeatingRows.find(function (repeatingRow) { return repeatingRow.rowIndex === i; });
            var rowElement = repeatingRow
                ? {
                    type: "tableRepeatingRow",
                    isVoid: false,
                    data: __assign({}, (0, CommonUtils_1.includeIf)(!!repeatingRow.repeatingToken, { repeatingToken: repeatingRow.repeatingToken })),
                    children: [],
                }
                : {
                    type: "tableRow",
                    isVoid: false,
                    children: [],
                };
            var currentCellNum = 0;
            try {
                for (var row_1 = (e_1 = void 0, __values(row)), row_1_1 = row_1.next(); !row_1_1.done; row_1_1 = row_1.next()) {
                    var cell = row_1_1.value;
                    var cellContent = void 0;
                    if (cell.length === 0) {
                        (0, TokenizationErrorRecorder_1.sendEmptyLayoutToSentry)("table", "tableCell", "deserialisation");
                        cellContent = { children: [(0, Paragraph_1.createParagraphNode)()] };
                    }
                    else {
                        cellContent = (0, Deserialise_1.deserialiseNode)(cell, commentTracker);
                    }
                    var cellNode = {
                        type: "tableCell",
                        isVoid: false,
                        children: cellContent.children,
                    };
                    rowElement.children.push(cellNode);
                    if (cellContent.selection) {
                        tableNode.key = "tempTableKey";
                        var tablePath = (0, Deserialise_1.getPath)(tableNode.key, content.children.concat(tableNode));
                        if (cellContent.selection.anchor.path) {
                            cellContent.selection.anchor.path = tablePath.concat([currRowNum, currentCellNum], cellContent.selection.anchor.path);
                        }
                        if (cellContent.selection.focus.path) {
                            cellContent.selection.focus.path = tablePath.concat([currRowNum, currentCellNum], cellContent.selection.focus.path);
                        }
                        if (content.selection) {
                            if (content.selection.anchor.path) {
                                content.selection.focus = cellContent.selection.focus;
                            }
                            else {
                                content.selection.anchor = cellContent.selection.anchor;
                            }
                        }
                        else {
                            content.selection = cellContent.selection;
                        }
                        delete tableNode.key;
                    }
                    currentCellNum++;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (row_1_1 && !row_1_1.done && (_a = row_1.return)) _a.call(row_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            tableNode.children.push(rowElement);
            currRowNum++;
        };
        for (var i = 0; i < token.cells.length; i++) {
            _loop_1(i);
        }
        return tableNode;
    }, serialise: function (node, editor, commentTracker, selection) {
        var tableRows = node.children;
        var newToken = {
            type: "block",
            subType: "table",
            rows: tableRows.length,
            columns: tableRows[0].children.length,
            columnBorders: node.data.columnBorders,
            cells: [],
        };
        newToken.cells = [];
        for (var i = 0; i < tableRows.length; i++) {
            var row = tableRows[i];
            if (row.type === "tableRepeatingRow") {
                var repeatingRow = {
                    rowIndex: i,
                };
                if ("data" in row && row.data.repeatingToken) {
                    repeatingRow.repeatingToken = row.data.repeatingToken;
                }
                newToken.repeatingRows = newToken.repeatingRows || [];
                newToken.repeatingRows.push(repeatingRow);
            }
            var cellTokens = row.children.map(function (cell) {
                var serialisedCell = (0, Serialise_1.serialiseElements)(cell.children, editor, commentTracker, selection);
                if (serialisedCell.length === 0) {
                    (0, TokenizationErrorRecorder_1.sendEmptyLayoutToSentry)("table", "tableCell", "serialisation");
                }
                return serialisedCell;
            });
            newToken.cells.push(cellTokens);
        }
        var tableTokens = [newToken];
        return tableTokens;
    }, onAddWidget: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var tableNode, startPoint, _c, path;
        var _d;
        var editor = _b.editor, di = _b.di;
        return __generator(this, function (_e) {
            if (!editor.selection) {
                return [2];
            }
            tableNode = createTableNode();
            startPoint = slate_1.Range.start(editor.selection).path;
            _c = __read((_d = (0, Utils_1.getClosestBlock)(editor, startPoint)) !== null && _d !== void 0 ? _d : [], 2), path = _c[1];
            if (!path) {
                return [2];
            }
            slate_1.Editor.withoutNormalizing(editor, function createTableAndSetCursorToFirstCell() {
                slate_1.Transforms.removeNodes(editor, { at: path });
                slate_1.Transforms.insertNodes(editor, tableNode, { at: path });
                var _a = __read(slate_1.Editor.nodes(editor, {
                    at: path,
                    match: function (node) { return slate_1.Element.isElement(node) && node.type === "tableRow"; },
                }), 1), _b = __read(_a[0], 2), firstTableRowPath = _b[1];
                var _c = __read(slate_1.Editor.nodes(editor, { at: firstTableRowPath, match: Text.isText }), 1), _d = __read(_c[0], 2), textPath = _d[1];
                slate_1.Transforms.select(editor, textPath);
            });
            (0, lodash_1.defer)(function () {
                slate_react_1.ReactEditor.focus(editor);
            });
            return [2];
        });
    }); }, validContainers: ["contentLoopBody"], validEditors: ["standard", "agreement"], normalizeWidget: function (node, path, editor) {
        for (var i = 0; i < node.children.length; i++) {
            if (node.children[i].type !== "tableRow" && node.children[i].type !== "tableRepeatingRow") {
                slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                return true;
            }
        }
        if (node.children.length === 0) {
            slate_1.Transforms.insertNodes(editor, (0, exports.createTableRowNode)(), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            return true;
        }
        return false;
    }, widgetAdderConfig: {
        icon: react_1.default.createElement(icons_1.WidgetTable, null),
        tags: ["rows", "cells"],
        displayName: "Table",
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.Table, containerNodeConfiguration: {
        showWidgetAdder: false,
        hasContainerManagedChildren: true,
        allowDragAndDropChildren: false,
        preventTextContextualStyles: true,
    } }));
